import React, {useEffect, useState} from "react";
import {NavLink} from "react-router-dom";
import {
    Link,
    Grid,
    Box,
    Typography,
    makeStyles,
    useMediaQuery,
    Hidden,
    Modal,
    Backdrop,
    Fade,
    Button
} from "@material-ui/core";
import {colorAdditional, colorBorder, colorWhite} from "../../Constants/theme";
import API from "../../helpers/apiHelpers";
import {useTheme} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {privacyPolicyURL, termsOfUseURL, paymentUser} from "../../Constants/api";
import {useHistory} from "react-router-dom";
import {getUserByID, logOutUser} from "../../redux/user/user.actions";
import {setIsLogOut} from "../../redux/common/common.reducers";
import {setUserInfo, setModal} from "../../redux/common/common.reducers";
import {partners} from "../../Constants/partners";

const useStyles = makeStyles((theme) => ({
    link: {
        border: "none",
        paddingLeft: "15px",
        lineHeight: "26px",
        marginBottom: "24px",
    },
    activeLink: {
        borderLeft: `3px solid ${colorBorder}`,
        borderBottom: "none",
    },
    [theme.breakpoints.down("sm")]: {
        link: {
            display: "flex",
            alignItems: "center",
            border: "none",
            padding: "12px",
            lineHeight: "26px",
            marginBottom: "0px",
        },
        activeLink: {
            borderLeft: "none",
            borderBottom: `2px solid ${colorBorder}`
        },
    },
    modal: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        [theme.breakpoints.down("sm")]: {
            width: "99%",
            margin: "0 auto"
        }
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 2),
        display: "flex",
        flexDirection: "column"
    },
    button: {
        width: 110,
        marginTop: 10,
        marginBottom: 10
    }
}));


const NavLinksComponent = () => {
    const classes = useStyles();
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const user = useSelector((state: RootState) => state?.user);
    const subscription = useSelector((state: RootState) => state?.common?.isLeaveFormFilled?.ownerSubscriptionPlans);
    const [hasSubscription, setHasSubcription] = useState(false);
    const history = useHistory();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (user.userId) {
            dispatch(getUserByID(user.userId)).then(res => {
                dispatch(setUserInfo(res));
            });
        }
    }, []);

    useEffect(() => {
        if (subscription?.length > 0) {
            setHasSubcription(true);
        } else {
            setHasSubcription(false);
        }
    }, [subscription]);

    return (
        <>
            {
                API.role === "ADMIN" &&
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink} to="/admin">
                    <Typography color="textPrimary">Admin</Typography>
                </Link>
            }
            {
                API.role === "OWNER" &&
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink} to="/pets">
                    <Typography color="textPrimary">Pets</Typography>
                </Link>
            }
            {
                API.role !== "PARTNER" &&
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                    to="/appointments">
                    <Typography color="textPrimary">Appointments</Typography>
                </Link>
            }
            {
                API.role === "PARTNER" &&
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                    to="/partnerDashboard">
                    <Typography color="textPrimary">Dashboard</Typography>
                </Link>
            }
            {
                API.role === "ADMIN" &&
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                    to="/partnerDashboard">
                    <Typography color="textPrimary">Dashboard</Typography>
                </Link>
            }
            <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                to="/dashboardProfile">
                <Typography color="textPrimary">Profile</Typography>
            </Link>
            {
                API.role === "PARTNER" &&
                <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                    to="/preferences">
                    <Typography color="textPrimary">Preferences</Typography>
                </Link>
            }
            {API.role === "OWNER" && !isWhiteLabel && hasSubscription &&
            <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                to="/subscriptionDetails">
                <Typography color="textPrimary">Subscription</Typography>
            </Link>
            }
			{
				API.role === "OWNER" && user.email === paymentUser &&
				<Link component={NavLink} className={classes.link} activeClassName={classes.activeLink} to="/paymentInformation">
					<Typography color="textPrimary">Payment Information</Typography>
				</Link>
			}
            {
                API.role === "OWNER" && !isWhiteLabel && !hasSubscription &&
                <>
                    <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                        to="/referrals">
                        <Typography color="textPrimary">Refer a friend</Typography>
                    </Link>
                    <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                        to="/creditSummary">
                        <Typography color="textPrimary">Bundle Summary</Typography>
                    </Link>
                    <Link component={NavLink} className={classes.link} activeClassName={classes.activeLink}
                        to="/purchaseCredits">
                        <Typography color="textPrimary">Purchase Bundles</Typography>
                    </Link>
                </>
            }
        </>
    );
};

const Navigation = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const history = useHistory();
    const partnerId = useSelector((state: RootState) => state?.branding.partnerId);
    const dispatch = useAppDispatch();
    const [showContactUs, setShowContactUs] = useState(false);

    const handleClick = () => {
        setShowContactUs(false);
    };
    //onClick={(e) => {e.preventDefault(); setShowContactUs(true)}}

    return (
        <>
            <Grid container direction="column">
                <Box marginBottom="32px">
                    <Grid container direction="column">
                        <NavLinksComponent/>
                    </Grid>
                </Box>
                <a href={termsOfUseURL} target="_blank" rel="noreferrer" className={classes.link}>
                    <Typography color="textPrimary">Terms of Service</Typography>
                </a>
                <a href={partners.find(item => item.id === partnerId)?.doc || privacyPolicyURL} target="_blank" rel="noreferrer" className={classes.link}>
                    <Typography color="textPrimary">Privacy Policy</Typography>
                </a>
                <Link component={NavLink} className={classes.link} to="#" onClick={(e) => {
                    e.preventDefault();
                    setShowContactUs(true);
                }}>
                    <Typography color="textPrimary">Contact Us</Typography>
                </Link>
                <a
                    style={{textDecoration: "none", cursor: "pointer"}}
                    onClick={async () => {
                        dispatch(setModal(true));
                    }}
                    className={classes.link}
                >
                    <Typography color="textPrimary">Sign Out</Typography>
                </a>
            </Grid>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={showContactUs}
                onClose={() => setShowContactUs(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={showContactUs}>
                    <div className={classes.paper}>
                        <Typography variant="h2" gutterBottom>
                            Contact Us
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Hours: <span style={{fontWeight: 400}}>9am - midnight EST</span>
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Email: <a href="mailto:support@helloralphie.com"
                                style={{fontWeight: 400, textDecoration: "none"}}>support@helloralphie.com</a>
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Phone <span style={{fontWeight: 400}}>(Call or Text): <a href="tel:9172590518" style={{
                                fontWeight: 400,
                                textDecoration: "none"
                            }}>(917) 259 - 0518</a></span>
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Chat <span style={{fontWeight: 400}}>Click the chat icon in the bottom right to connect with us right now.</span>
                        </Typography>
                        <Button
                            variant="outlined"
                            color="primary"
                            className={classes.button}
                            onClick={() => setShowContactUs(false)}
                        >
                            Close
                        </Button>
                        <Typography variant="caption">
                            In the case of a life threatening emergency,
                        </Typography>
                        <Typography variant="caption" gutterBottom>
                            seek care at the closest emergency clinic.
                        </Typography>
                    </div>
                </Fade>
            </Modal>
        </>
    );
};

export default React.memo(Navigation);
